module.exports = require('../../tailwind.config.js');
